import {useEffect, useState} from 'react'
import {Dispatch} from 'redux'
import {Form, Formik} from 'formik'
import {SearchComponent} from '../../../../../services/table/SearchComponent'
import {RootState} from '../../../../../../setup'
import {shallowEqual, useDispatch, useSelector} from 'react-redux'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers'
import moment from 'moment'
import {KTSVG, getFilterBadgeCount} from '../../../../../../_metronic/helpers'
import {Menu} from '@mui/material'
import {getCountriesList} from '../../../../../../setup/redux/subscription_plans/actions'
import {getTeamSizeList} from '../../../../../../setup/redux/auth/actions'
import {customSelectHoverStyles} from '../../../../../services/Styles'
import CustomSelect from '../../../../../components/common/Select'

interface FilterData {
  team_size_id: string
  start_date: string
  end_date: string
  country: string
  page: number
}

const ListHeader = ({updateState, ...props}: any) => {
  const [filterData, setFilterData] = useState<FilterData>({
    team_size_id: 'all',
    start_date: '',
    end_date: '',
    country: 'all',
    page: 1,
  })
  const {teamSizeList}: any = useSelector<RootState>(
    (state) => ({teamSizeList: state.auth.teamSizeList}),
    shallowEqual
  )
  const [anchorEl, setAnchorEl] = useState(null)
  const dispatch: Dispatch<any> = useDispatch()
  const open = Boolean(anchorEl)
  const {countries}: any = useSelector<RootState>(
    (state) => ({
      countries: state.subscriptionPlans.countriesDropdown,
    }),
    shallowEqual
  )

  useEffect(() => {
    dispatch(getCountriesList())
    dispatch(getTeamSizeList())
  }, [dispatch])

  const handleClickMenu = (event: any) => {
    setAnchorEl(event?.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  useEffect(() => {
    if (filterData) {
      updateState({...filterData})
    }
  }, [filterData])

  return (
    <div className={`filterHeaderVisible pt-5 card-header border-0 `}>
      <SearchComponent
        updateState={updateState}
        title='Type a company name, email or mobile number here to search'
      />
      <div className='d-flex justify-content-start' data-kt-user-table-toolbar='base'>
        <Formik
          initialValues={filterData}
          onSubmit={(values) => {
            setFilterData({
              start_date: values?.start_date ? values?.start_date : '',
              end_date: values?.end_date ? values?.end_date : '',
              team_size_id: values?.team_size_id ? values?.team_size_id : 'all',
              country: values?.country ? values?.country : 'all',
              page: 1,
            })
            handleClose()
          }}
        >
          {({values, handleBlur, handleChange, setFieldValue, dirty}) => {
            const teamOptions =
              [{value: 'all', label: 'All'}].concat(
                teamSizeList?.map((a: any) => ({value: a.id, label: a.size}))
              ) || []
            const countries_dropdown =
              [{value: 'all', label: 'All'}].concat(
                countries?.map((a: any) => ({
                  value: a.inspection_company_country,
                  label: a.inspection_company_country,
                }))
              ) || []
            const appliedCount: number = getFilterBadgeCount(values)
            return (
              <div className='card-toolbar justify-content-between'>
                <button
                  id='filter-menu'
                  aria-controls={open ? 'filter-menu' : undefined}
                  aria-haspopup='true'
                  aria-expanded={open ? 'true' : undefined}
                  className={'cursor-pointer symbol btn btn-white shadow-sm'}
                  onClick={handleClickMenu}
                >
                  <KTSVG path='/media/icons/duotune/arrows/Filters.svg' className='svg-icon-2' />
                  Filter
                  {!!appliedCount && (
                    <span className={`custom-round-badge translate-top badge-circle badge-primary`}>
                      {appliedCount}
                    </span>
                  )}
                </button>
                <Menu
                  id='filter-menu'
                  MenuListProps={{
                    'aria-labelledby': 'filter-menu',
                  }}
                  anchorEl={anchorEl}
                  className='filter-menu-container'
                  open={open}
                  onClose={handleClose}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                >
                  <div className='menu-item px-5 mt-2'>
                    <h3>Filter by</h3>
                  </div>
                  <div className='menu-item px-5 pt-10 text-muted'>
                    <Form className='form d-flex justify-content-start mt-3 flex-column gap-4'>
                      <div className='form-group  dateIconCal position-relative'>
                        <label className='form-label'>Team Size</label>
                        <CustomSelect
                          options={[...teamOptions]}
                          value={teamOptions?.find?.((a) => a.value === values.team_size_id)}
                          name='team_size_id'
                          className='text-capitalize'
                          placeholder='Team Size'
                          onChange={(selectedOption) => {
                            const newTeam = selectedOption ? selectedOption.value : ''
                            setFieldValue('team_size_id', newTeam)
                          }}
                          onBlur={() => {
                            handleBlur({target: {name: 'team_size_id'}})
                          }}
                          menuPortalTarget={document.body}
                          styles={{
                            ...customSelectHoverStyles,
                            menuPortal: (base) => ({...base, zIndex: 9999}),
                          }}
                          classNamePrefix='react-custom-select'
                        />
                      </div>
                      <div className='form-group  dateIconCal position-relative'>
                        <label className='form-label'>Country</label>
                        <CustomSelect
                          options={[...countries_dropdown]}
                          value={countries_dropdown?.find?.((a) => a.value === values.country)}
                          name='country'
                          className='text-capitalize'
                          placeholder='Country'
                          onChange={(selectedOption) => {
                            const newCountry = selectedOption ? selectedOption.value : ''
                            setFieldValue('country', newCountry)
                          }}
                          onBlur={() => {
                            handleBlur({target: {name: 'country'}})
                          }}
                          menuPortalTarget={document.body}
                          styles={{
                            ...customSelectHoverStyles,
                            menuPortal: (base) => ({...base, zIndex: 9999}),
                          }}
                          classNamePrefix='react-custom-select'
                        />
                      </div>
                      <div className='form-group  dateIconCalParent'>
                        <div className='date_picker_UI dateIconCal position-relative'>
                          <label className='form-label'>Start Date</label>
                            <LocalizationProvider dateAdapter={AdapterMoment}>
                              <DatePicker
                                format='DD/MM/YYYY'
                                value={
                                  values.start_date
                                    ? moment(values.start_date)
                                    : null
                                }
                                maxDate={values?.end_date ? moment(values.end_date) : undefined}
                                onChange={(date) => {
                                  const event = {
                                    target: {
                                      name: 'start_date',
                                      value: date !== null ? moment(date).format('YYYY-MM-DD') : '',
                                    },
                                  }
                                  handleChange(event)
                                }}
                                slotProps={{
                                  textField: {
                                    placeholder: 'Choose Date',
                                    InputProps: {
                                      disableUnderline: true,
                                      className: 'form-control pr-0',
                                    },
                                    style: { width: '100%' }
                                  },
                                }}
                              />
                            </LocalizationProvider>
                          {/* <MuiPickersUtilsProvider utils={MomentUtils}>
                            <DatePicker
                              InputProps={{
                                disableUnderline: true,
                                className: 'form-control pr-0',
                              }}
                              error={false}
                              helperText={<i className='fa fa-calendar calIcon'></i>}
                              autoOk
                              format='DD/MM/yyyy'
                              margin='normal'
                              placeholder='Choose Date'
                              maxDate={values?.end_date || moment().format('YYYY-MM-DD')}
                              value={
                                values.start_date
                                  ? moment(values.start_date).format('YYYY-MM-DD')
                                  : null
                              }
                              onChange={(date) => {
                                let event = {
                                  target: {
                                    name: 'start_date',
                                    value: date !== null ? moment(date).format('YYYY-MM-DD') : '',
                                  },
                                }
                                handleChange(event)
                              }}
                            />
                          </MuiPickersUtilsProvider> */}
                        </div>
                      </div>
                      <div className='form-group mb-2  dateIconCalParent'>
                        <div className='date_picker_UI dateIconCal position-relative'>
                          <label className='form-label'>End Date</label>
                            <LocalizationProvider dateAdapter={AdapterMoment}>
                              <DatePicker
                                format='DD/MM/YYYY'
                                value={
                                  values.end_date
                                    ? moment(values.end_date)
                                    : null
                                }
                                minDate={values.start_date ? moment(values.start_date) : undefined}
                                onChange={(date) => {
                                  const event = {
                                    target: {
                                      name: 'end_date',
                                      value: date !== null ? moment(date).format('YYYY-MM-DD') : '',
                                    },
                                  }
                                  handleChange(event)
                                }}
                                slotProps={{
                                  textField: {
                                    placeholder: 'Choose Date',
                                    InputProps: {
                                      disableUnderline: true,
                                      className: 'form-control pr-0',
                                    },
                                    style: { width: '100%' }
                                  },
                                }}
                              />
                            </LocalizationProvider>
                          {/* <MuiPickersUtilsProvider utils={MomentUtils}>
                            <DatePicker
                              InputProps={{
                                disableUnderline: true,
                                className: 'form-control pr-0',
                              }}
                              error={false}
                              helperText={<i className='fa fa-calendar calIcon'></i>}
                              autoOk
                              format='DD/MM/yyyy'
                              margin='normal'
                              placeholder='Choose Date'
                              {...(values.start_date ? {minDate: values.start_date} : {})}
                              value={
                                values.end_date
                                  ? moment(values.end_date).format('YYYY-MM-DD')
                                  : null
                              }
                              onChange={(date) => {
                                let event = {
                                  target: {
                                    name: 'end_date',
                                    value: date !== null ? moment(date).format('YYYY-MM-DD') : '',
                                  },
                                }
                                handleChange(event)
                              }}
                            />
                          </MuiPickersUtilsProvider> */}
                        </div>
                      </div>
                      <div className='form-group mb-2 d-flex gap-2'>
                        <button
                          type='reset'
                          className='btn btn-link flex-grow-1'
                          data-kt-menu-dismiss='true'
                          onClick={() => {
                            setFilterData({
                              start_date: '',
                              end_date: '',
                              team_size_id: 'all',
                              country: 'all',
                              page: 1,
                            })
                            handleClose()
                          }}
                          disabled={!appliedCount}
                        >
                          Reset
                        </button>
                        <button
                          type='submit'
                          className='btn btn-primary flex-grow-1'
                          data-kt-menu-dismiss='true'
                          disabled={!dirty}
                        >
                          Apply
                        </button>
                      </div>
                    </Form>
                  </div>
                </Menu>
              </div>
            )
          }}
        </Formik>
      </div>
    </div>
  )
}

export {ListHeader}
